import React, { Component, useMemo, useState } from "react";
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import {loadStripe} from '@stripe/stripe-js';
import { CheckoutProvider } from '@stripe/react-stripe-js';
import { PaymentElement, AddressElement, useCheckout } from '@stripe/react-stripe-js';
import './sign-up.css'
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_API_KEY);


const validateEmail = async (email, checkout) => {
    const updateResult = await checkout.updateEmail(email);
    const isValid = updateResult.type !== "error";
  
    return { isValid, message: !isValid ? updateResult.error.message : null };
  }
  
  const EmailInput = ({ email, setEmail, error, setError }) => {
    const checkout = useCheckout();
  
    const handleBlur = async () => {
      if (!email) {
        return;
      }
  
      const { isValid, message } = await validateEmail(email, checkout);
      if (!isValid) {
        setError(message);
      }
    };
  
    const handleChange = (e) => {
      setError(null);
      setEmail(e.target.value);
    };
  
    return (
      <>
      <div>
        <label className="w-100">
          <input
            id="email"
            type="text"
            placeholder="email"
            value={email}
            onChange={handleChange}
            onBlur={handleBlur}
            className={error ? "error form-control bg-dark text-white text-center" : "form-control bg-dark text-white text-center"}
          />
        </label>
        {error && <div id="email-errors" className="text-white text-center">{error}</div>}
      </div>
      </>
    );
  };
  
  
  const StripeCheckoutForm = () => {
    const checkout = useCheckout();
  
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState(null);
    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      setIsLoading(true);

      if(email) {
          fetch(process.env.REACT_APP_VERIFY_EMAIL + email).then(result => result.json()).then(async (json) => {
    
            if(json.success){
                const { isValid, message } = await validateEmail(email, checkout);
                if (!isValid) {
                    setEmailError(message);
                    setMessage(message);
                    setIsLoading(false);
                }
            
                const confirmResult = await checkout.confirm();
            
                if (confirmResult.type === 'error') {
                    setMessage(confirmResult.error.message);
                }
            
                setIsLoading(false);
            } else {
                alert(json.message)
                window.location.replace('/signup');
            }
          })
      } else {
        alert("Email is required!")
        window.location.replace('/signup');
      }
      
    };
  
    return (
      <form onSubmit={handleSubmit}>
        <EmailInput
          email={email}
          setEmail={setEmail}
          error={emailError}
          setError={setEmailError}
        />
        <h4 className="text-white text-center pt-5">Billing Address</h4>
        <AddressElement options={{mode: 'billing'}} />
        <h4 className="text-white text-center pt-5 pb-3">Payment</h4>
        <PaymentElement id="payment-element" />
        <div className="text-center p-4">  
          <button disabled={isLoading} id="submit" className="btn btn-success btn-lg submit-button">
            {isLoading ? (
              <div>Loading...</div>
            ) : (
              `Pay ${checkout.total.total.amount} / Month`
            )}
          </button>
        </div>
        {/* Show any error or success messages */}
        {message && <div id="payment-message" className="text-white text-center">{message}</div>}
      </form>
    );
}


const StripePaymentSystem = () => {
    const promise = useMemo(() => {
        return fetch(process.env.REACT_APP_CREATE_CHECKOUT_SESSION, {
            method: 'POST',
         }).then((res) => res.json()).then((data) => data.clientSecret);
    }, []);
  
    const appearance = {
      theme: 'night',
    };
  
    return (
      <div className="StripePaymentSystem">
          <CheckoutProvider
            stripe={stripePromise}
            options={{
              fetchClientSecret: () => promise,
              elementsOptions: {appearance},
            }}
          >
          <StripeCheckoutForm/>
          </CheckoutProvider>
      </div>
    )
}


class SignUp extends Component {
    constructor(){
        super();
        this.state = {
            signUpUserName: '',
            signUpPassword: '',
            userSignUp: {},
            signUpEmail: ''
        }
    }

    bargainCount = () => {
      return this.props.bargainCount
    }

    filterBargains = (bargain) => {
      if(bargain.companySummary) {
        const bargainPercentage = ((bargain.companySummary.MarketCapitalization / bargain.ncav) * 100).toFixed(2);
        if(bargain.isOutdated === false && bargainPercentage < 100.0 && bargain.ncav > 0) {
          return bargain
        }
      }
    }

    displaySignUpForm = () => {
        return (
            <div className="my-form border border-dark p-5">
                <h4 className="text-white display-4 text-center mb-5">Ready to invest like the pros?...</h4>
                <h4 className="text-white display-4 text-center mb-5">Tired of the same old investments and looking for something new?...</h4>
                {/* <h4 className="text-white display-4 text-center mb-5">Sick of investments going south?...</h4> */}
                {/* <h4 className="text-white display-4 text-center mb-5">Not a fan of the crypto craze?...</h4> */}
                <h4 className="text-white display-4 text-center mb-5">Want to invest using an age old strategy?...</h4>
                {/* <h4 className="text-white display-4 text-center mb-5">Want to invest long term?...</h4> */}
                <h4 className="text-white display-4 text-center mb-5">Ready to get serious about stock picking?...</h4>
                <h4 className="text-white display-4 text-center mb-5">Looking for a stock screener that actually brings results?...</h4>
                <h4 className="text-white display-4 text-center mb-5">Sign up now!</h4>
                <div className="text-center mb-5">
                    <span className="text-warning">Fair warning: The investing process is highly individualized and results will differ greatly from person to person depending on investments made, timing, allocation etc. Please take this into consideration and use caution before investing. </span>
                    <span className="text-warning">Bargain-Basket is built using limited resources, if any of these resources become unavailable then Bargain Basket may cease to exist.</span>
                </div>
                <div className="text-center mb-5">
                    <span className="text-danger">All sales are final, no refunds. <br/> Do not lose your password or else your account may become unrecoverable.<br/>Cancel your subscription at any time.<br/>Bargain-Basket is subject to price changes.</span>
                </div>
                <div className="text-center mb-5">
                    <span className="text-success">50,000 companies searched weekly.</span> <br/>
                    <span className="text-success">Currently ({<>{this.bargainCount()}</>}) bargains to choose from.</span> <br/>
                    <span className="text-success">Bargains are updated daily.</span>
                </div>
                <StripePaymentSystem/>
            </div>
        )
    }

    render() {
        if(this.props.userLoggedIn === true){
            return <Redirect to="/" />
        } else {
            return(
                <div id="signup" className="d-flex align-items-center justify-content-center">
                    <div className="container fade-in-fwd">
                        <div className="row">
                            <div className="col-12 p-5">
                                {this.displaySignUpForm()}
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }

}

const mapStateToProps = state => {
    return {
        userLoggedIn: state.userState.userLoggedIn,
        bargainCount: state.bargainState.bargainCount
    }
}

export default connect(mapStateToProps)(SignUp);